import css from './index.module.scss';
import OverView from './components/OverView';
import { getDetaileMoreProducts } from '@/utils';
import { useGlobal } from '@/utils/useGlobal';
import { LineSpace } from '@/componentsH5/ProductComponents';
import { BannerModule, TextWithImage } from '@/componentsH5/ProductDetailComponents';
import First from '@/componentsH5/ProductDetailComponents/MultiSellPointsModule/First';
import { EFACCharging, EFSCharging, EFCCharging } from '@/components/UI/svg/ProductStatic';
import { getImageLocal, getImageSpec } from '@/utils/locals';
import OtherList from '@/components/ProductCommon/OtherList';
import AppPointRiverBase from '@/components/AppPoint/RiverBaseH5';
import { SHOW_APP_POINT_SITES } from '@/constants';

const defaultStyle = {
    background: 'transparent',
    padding: '0',
    margin: '0 auto',
    border: 'none',
    borderRadius: '0',
};

export default function RiverModule({ cssStyle }: any) {
    const styles = { ...defaultStyle, ...cssStyle };
    const { gloproductlist, useLang, useRouter, Link } = useGlobal();
    const { locale } = useRouter();
    const imgSpec = getImageSpec(locale, ['au', 'uk', 'cn', 'de', 'fr', 'es', 'it', 'eu', 'za']);
    const appImgLocal = getImageLocal(locale, ['jp', 'de', 'fr', 'cn']);
    const { t } = useLang('riverportablepowerstation');
    const webpUrl = '/media/river/h5/';

    return (
        <div
            className={`${css.river} riverModule`}
            style={{
                background: styles.background,
                padding: styles.padding,
                margin: styles.margin,
                border: styles.border,
                borderRadius: styles.borderRadius,
            }}
        >
            <BannerModule
                data={[
                    {
                        bgImgs: [`banner_${imgSpec}.webp`, `banner_${imgSpec}.jpg`],
                        title: t('river.banner_title'),
                        des: t('river.banner'),
                    },
                ]}
                config={{
                    webpUrl,
                }}
            />
            {/* 新版本一图看懂 */}
            <OverView />
            <LineSpace height={0.8} background="transparent" />
            <div className="textWithImg1">
                <TextWithImage
                    config={{
                        isShowVideo: false,
                        fullScreen: false,
                        position: 'top',
                        text: 'left',
                        phraseColor: '#757575',
                        synopsisFontSize: locale === 'jp' ? '.23' : '.24rem',
                        webpUrl,
                    }}
                    data={{
                        title: t('river.capacity'),
                        synopsis: t('river.capacity_sub_title'),
                        desc: t('river.capacity_desc_h5'),
                        phrase: t('river.capacity_notice'),
                        img_url: ['sunset.webp', 'sunset.jpg'],
                        video_src: '',
                    }}
                />
            </div>
            <LineSpace height={1.2} background="transparent" />
            <div className="textImg">
                <TextWithImage
                    config={{ isShowVideo: false, position: 'top', text: 'left', webpUrl }}
                    data={{
                        title: t('river.AC_output'),
                        synopsis: t('river.AC_output_sub_title'),
                        desc: t.rich('river.AC_output_desc', {
                            line1: (text: string) => (
                                <Link className="ef-link__page is-mobile" href="/x-boost" newWin>
                                    {text}
                                </Link>
                            ),
                        }),
                        noUseHtmlAttr: true,
                        arr: [
                            { num: 600, eum: 'w', desc: t('river.AC_output_desc1') },
                            {
                                num: locale === 'cn' ? 1800 : 1200,
                                eum: 'w',
                                desc: t('river.AC_output_desc2'),
                            },
                        ],
                        img_url: ['deltaProLg.webp', 'deltaProLg.jpg'],
                        video_src: '',
                    }}
                />
            </div>
            <LineSpace height={1.2} background="transparent" />
            <First
                data={{
                    guide: { text: t('river.charging') },
                    title: { text: t('river.charging_desc') },
                    desc: { text: '' },
                    items: [
                        {
                            icon: <EFACCharging />,
                            title: t('river.charging_title1'),
                            des: t('river.charging_desc1'),
                            directUrl: '/',
                        },
                        {
                            icon: <EFSCharging />,
                            title: t('river.charging_title2'),
                            des: t('river.charging_desc2'),
                            directUrl: '/',
                        },
                        {
                            icon: <EFCCharging />,
                            title: t('river.charging_title3'),
                            des: t('river.charging_desc3'),
                            directUrl: '/',
                        },
                    ],
                }}
            />
            <LineSpace height={1.2} background="transparent" />
            <div className="textImg battery-system">
                <TextWithImage
                    config={{ isShowVideo: false, position: 'bottom', webpUrl }}
                    data={{
                        title: t('river.battery_system'),
                        synopsis: t('river.battery_system_sub_title'),
                        desc: t('river.battery_system_desc'),
                        img_url: ['chip.webp', 'chip.jpg'],
                        video_src: '',
                    }}
                />
            </div>
            <LineSpace height={1.2} background="transparent" />
            {!SHOW_APP_POINT_SITES.includes(locale) && (
                <div className="textImg">
                    <TextWithImage
                        config={{
                            isShowVideo: false,
                            position: 'top',
                            text: 'left',
                            synopsisFontSize: locale === 'de' ? 0.23 : 0.24,
                            webpUrl,
                        }}
                        data={{
                            title: t('river.app_support'),
                            synopsis: t('river.app_support_sub_title'),
                            desc: t('river.app_support_desc'),
                            img_url: [`phone_${appImgLocal}.webp`, `phone_${appImgLocal}.jpg`],
                            video_src: '',
                        }}
                    />
                </div>
            )}
            {SHOW_APP_POINT_SITES.includes(locale) && <AppPointRiverBase />}
            <LineSpace height={1.2} background="transparent" />
            <section className="RIVER-Plus">
                <TextWithImage
                    config={{
                        isShowVideo: false,
                        fullScreen: false,
                        position: 'top',
                        text: 'left',
                        webpUrl,
                    }}
                    data={{
                        title: t('river.plus'),
                        synopsis: t('river.plus_sub_title'),
                        desc: t('river.plus_desc'),
                        img_url: [`360wh_${imgSpec}.webp`, `360wh_${imgSpec}.jpg`],
                        video_src: '',
                    }}
                />
                <LineSpace height={1.2} background="transparent" />
            </section>
            <OtherList
                data={getDetaileMoreProducts(gloproductlist, ['product_ps_river_river_768', 'product_ps_delta_delta_2', 'product_ps_delta_delta_max'])}
            />
        </div>
    );
}
